import { LRUCache } from 'lru-cache';
import ContentTypesQuery from 'graphql/queries/content-types';

import client from './graphql';

const FIVE_MINUTES = 5 * 60 * 1000;

const cache = new LRUCache({
  ignoreFetchAbort: true,
  allowStale: true,
  max: 1000,
  ttl: FIVE_MINUTES,
  fetchMethod: async (token) => fetchContentTypes(token),
});

/**
 * @param {string} token
 * @returns {Promise<Array<{contentType: string, name: string, slug: string}>>}
 */
export default async function getContentTypes(token) {
  return cache.fetch(token);
}

export async function fetchContentTypes(token) {
  try {
    const { contentTypes } = await client(token).query(ContentTypesQuery);
    return contentTypes;
  } catch (error) {
    console.error('Failed to get content types', error);
    return [];
  }
}
